import {h, Fragment} from "preact"
import { ArrowIcon } from './Icons';

export default function Select({
  value,
  onChange,
  className,
  options,
  classNameWrapper,
}) {
  return (
    <div className={`ns-relative ${classNameWrapper}`}>
      <select
        className={`ns-selection-dropdown-menu ns-text-align-left ${className}`}
        value={value}
        onChange={onChange}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
